// Centrální TanStack Query keys + fetchers (placeholder pro fáze 4-7).
// Umístění keys do jednoho místa, abychom mohli invalidovat selektivně.

export const queryKeys = {
  partnerSelf: ["partner", "self"] as const,
  portalUsers: ["partner", "portal-users"] as const,
  dashboard: ["partner", "dashboard"] as const,
  ordersAll: (filters?: Record<string, unknown>) => ["partner", "orders", filters || {}] as const,
  ordersWeek: (start: string) => ["partner", "orders", "week", start] as const,
  orderDetail: (orderNr: string) => ["partner", "orders", "detail", orderNr] as const,
  orderPhotos: (orderId: string) => ["partner", "orders", "photos", orderId] as const,
  orderDocs: (orderId: string) => ["partner", "orders", "docs", orderId] as const,
  orderComplaints: (orderId: string) => ["partner", "orders", "complaints", orderId] as const,
  invoicesAll: (filters?: Record<string, unknown>) =>
    ["partner", "invoices", filters || {}] as const,
  invoiceDetail: (nr: string) => ["partner", "invoices", "detail", nr] as const,
  balance: ["partner", "balance"] as const,
  mapPins: ["partner", "map", "pins"] as const,
  mapVehicles: ["partner", "map", "vehicles"] as const,
};
